import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { NotificacionComponent } from './notificacion.component';
import { NotificacionListComponent } from './notificacion-list.component';
import { LoguedGuardService } from '../security/logued-guard.service';
import { NotificacionResolver } from './notificacion.resolver';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SecurityModule } from '../security/security.module';
import { NotificacionFilterComponent } from './notificacion-filter.component';
import { NotificacionAddEditComponent } from './notificacion-add-edit.component';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NotificacionIdComponent } from './notificacion-id/notificacion-id.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [
    NotificacionComponent,
    NotificacionListComponent,
    NotificacionFilterComponent,
    NotificacionAddEditComponent,
    NotificacionIdComponent,
  ],
  exports: [
    NotificacionComponent,
    NotificacionListComponent,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    NotificacionResolver,
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
  ]
})
export class NotificacionModule { }



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion.module.ts